import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRDropdown } from '@base/src/app/models/qr-dropdown.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';
import { UtilsService } from '@base/src/app/services/utils.service';

@Component({
  selector: 'app-rendition-downloads',
  templateUrl: './rendition-downloads.component.html',
  styleUrls: ['./rendition-downloads.component.scss'],
})
export class RenditionDownloadsComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value!: string;

  readonly ICON_WARNING = Constants.ICONS.CHECK_2;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;

  dropdownMonths: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Mes',
    options: [],
  };

  dropdownYears: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Año',
    options: [],
  };

  dropdownOnlyYears: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Año',
    options: [],
  };

  // monthly → 0 | yearly → 1
  boxSelected: number | undefined = undefined;

  date = new Date();
  currentYear = this.date.getFullYear();
  currentMonth = this.date.getMonth();
  selectedMonth = '';
  selectedYear = this.currentYear.toString();
  selectedOnlyYear = '';
  monthList = this.utils.months.map((month) => month.spanishName);

  successDownload = false;

  constructor(private readonly utils: UtilsService) {}

  ngOnInit(): void {
    //me llega el value desde el panel
    //llega vacío si está en el primer paso del dialogo (elegir periodo)
    //me llega 'descarga correcta' si le pegó al servicio de descargas exitosamente
    if (this.value) {
      if (this.value == 'descarga correcta') {
        this.successDownload = true;
      }
    }
    this.selectedOnlyYear = this.dropdownOnlyYears.options[0];
    this.setDropdownYear();
    this.setDropdownMonth();
    this.selectedMonth = this.dropdownMonths.options[this.currentMonth];
    this.sendData();
  }

  setDropdownYear() {
    this.dropdownYears = {
      ...this.dropdownYears,
      options: this.utils.getYears(2013),
    };

    this.dropdownOnlyYears = {
      ...this.dropdownOnlyYears,
      options: this.utils.getYears(2013),
    };

    this.selectedOnlyYear = this.dropdownOnlyYears.options[0];
    this.selectedYear = this.dropdownYears.options[0];
  }

  setDropdownMonth() {
    let months = this.utils.months.map((month) => month.spanishName);
    if (this.selectedYear == this.currentYear.toString()) {
      months.splice(this.currentMonth + 1);
    }
    this.dropdownMonths = { ...this.dropdownMonths, options: months };
  }

  onSelectBox(box: number) {
    this.boxSelected = box;
    this.sendData();
  }

  //Cambia MES
  dropdownChangeMonth(selected: string): void {
    if (selected) this.selectedMonth = selected.toString();
    this.sendData();
  }

  //cambia AÑO
  dropdownChangeYear(selected: string): void {
    this.selectedYear = selected.toString();
    this.setDropdownMonth();
    this.sendData();
  }

  //cambia AÑO UNICO
  dropdownChangeOnlyYear(selected: string): void {
    if (selected) this.selectedOnlyYear = selected.toString();
    this.sendData();
  }

  //Avisa si el botón de acción puede estar habilitado
  //Envía periodo en value o envia 'ir a descargas'
  sendData() {
    let dialogEvent = undefined;
    let period: { year: string; month: null | string } = {
      year: '',
      month: null,
    };

    const monthPeriod = () => {
      const month = this.monthList.findIndex((m) => m == this.selectedMonth);

      let m: string | null = null;
      if (month >= 9) {
        m = (month + 1).toString();
      }
      if (month >= 0 && month <= 8) {
        m = '0' + (month + 1).toString();
      }
      return m;
    };

    if (this.boxSelected == 1) {
      period.year = this.selectedOnlyYear.toString();
    } else if (this.boxSelected == 0) {
      period.year = this.selectedYear.toString();
      period.month = monthPeriod();
    }

    if (!this.successDownload) {
      dialogEvent = {
        isButtonActionDisabled: this.boxSelected == undefined,
        value: period,
      };
    } else {
      dialogEvent = {
        isButtonActionDisabled: false,
        value: 'ir a descargas',
      };
    }
    this.dialogChange.emit(dialogEvent);
  }
}
